<template>
  <div>
    <contract-report-tabs
      v-if="isContractReport"
      :reports="reports"
    />
    <b-card
      v-if="loading"
      class="text-center py-5"
    >
      <b-spinner variant="primary" />
    </b-card>

    <b-alert
      v-else-if="!report"
      variant="danger"
      show
      class="mb-0"
    >
      Relatório não encontrado ou sem permissão de acesso.
    </b-alert>

    <div v-else>
      <iframe
        :src="embedUrl"
        width="100%"
        height="750px"
        frameborder="0"
        style="border: 0"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ContractReportTabs from '@/modules/contract/components/ContractReportTabs.vue'
import { CONTRACT_REPORT_TABS } from '@/constants/contract_report_tabs'
import { GET_BI_REPORTS } from '@/modules/shared/store/types'

export default {
  name: 'BiReportView',
  components: { ContractReportTabs },
  data() {
    return {
      reports: [],
      loading: true,
    }
  },
  computed: {
    isContractReport() {
      return CONTRACT_REPORT_TABS.some(tab => tab.key === this.$route.params.key)
    },
    report() {
      return this.reports.find(report => report.key === this.$route.params.key) || null
    },
    embedUrl() {
      if (!this.report) return ''
      // Converte https://<host>/u/... → https://<host>/embed/u/... nos dois domínios
      // do Looker Studio, já que parte dos reports responde 301 de lookerstudio para
      // datastudio. Remove também o sufixo /edit que vem colado nos links compartilhados.
      return this.report.url
        .replace(/\/edit\/?$/, '')
        .replace(/^(https:\/\/(?:lookerstudio|datastudio)\.google\.com)\/(?!embed\/)/, '$1/embed/')
    },
  },
  async created() {
    try {
      this.reports = await this.getBiReports()
    } catch {
      this.reports = []
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({ getBiReports: GET_BI_REPORTS }),
  },
}
</script>
